import VoiceRepository from '@/repositories/VoiceRepository'
import VoiceEntity from '@/entities/Voice'

export interface IPresenterParams {
  voiceRepository: VoiceRepository
  id: string
}

export interface IPresenter {
  voice: VoiceEntity | null
}

export default ({ voiceRepository, id }: IPresenterParams): IPresenter => {
  return {
    voice: voiceRepository.getVoiceById(id)
  }
}
